import { Action } from "redux";

export interface ILoadingState {
    loading?: boolean;
}

export class LoadingState implements ILoadingState {
    public loading?: undefined;
}

export const enum ActionTypes {
    IS_LOADING = "IS_LOADING"
}

export interface IShowLoadingAction extends Action {
    type: ActionTypes.IS_LOADING;
    data?: boolean;
}

export type LoadingActions = IShowLoadingAction;


// WEBPACK FOOTER //
// ./src/Store/Loading/LoadingActionTypes.tsx